export function buildContactListQuery({ page = 1, limit = 10, search = "", companyNames = [], activities = [] } = {}) {
  const query = new URLSearchParams({
    page: String(Math.max(1, Number(page) || 1)),
    limit: String(Math.max(1, Number(limit) || 10)),
  });
  if (String(search).trim()) query.set("search", String(search).trim());
  const names = companyNames.filter((name) => typeof name === "string").map((name) => name.trim()).filter(Boolean);
  if (names.length) query.set("company_names", JSON.stringify(names));
  if (activities.length) query.set("activity", JSON.stringify(activities));
  return query;
}

export function contactFilterPills(filters, onChange) {
  return ['companyNames', 'activities'].flatMap(field => (filters[field] || []).map(label => ({
    key: `${field}:${label}`, label,
    onDelete: () => onChange({ ...filters, [field]: filters[field].filter(value => value !== label) }),
  })));
}
